// extracted by mini-css-extract-plugin
export default {"ontarioEligibilityIcon":"OntarioHealthInsurancePlanEligibilityIndicator_ontarioEligibilityIcon__nZ6DY"};